module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('ed-modal', {
    attrs: {
      "title": 'FILTRAR RESULTADO' + ' (' + _vm.filterBadge + ')',
      "modal": _vm.showFilter,
      "onSave": _vm.handleFilter,
      "onClear": _vm.handleClear,
      "isModal": false,
      "width": "80%",
      "saveName": "Filtrar",
      "saveIcon": "fa fa-filter"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_vm._t("table-filter-content")], 2)]), _vm._v(" "), (_vm.onRegister || !_vm.disableInputSearch || !_vm.disableInputButtons) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row d-flex align-items-baseline"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "table-button d-flex flex-row"
  }, [(_vm.onRegister) ? _c('ed-button', {
    staticClass: "mb-1 mr-1",
    attrs: {
      "type": "primary",
      "icon": _vm.registerIcon,
      "loading": _vm.loadingRegister,
      "value": _vm.registerName
    },
    on: {
      "click": _vm.onRegister
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("table-button")], 2)]), _vm._v(" "), (!_vm.disableInputSearch) ? _c('div', {
    class: _vm.onRegister ?
      'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' :
      'col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12'
  }, [_c('b-input-group', {
    staticClass: "mt-3"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Digite aqui sua pesquisa e pressione ENTER..."
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.formData.search),
      callback: function($$v) {
        _vm.$set(_vm.formData, "search", $$v)
      },
      expression: "formData.search"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "title": "Clique para relizar sua busca..."
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("Buscar")])]), _vm._v(" "), (_vm.onFilter) ? _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "title": _vm.filterBadge + ' filtro(s) ativados, clique para saber mais...'
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    class: 'fa fa-filter' +
      (_vm.filterBadge > 0 ? ' faa-flash animated' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("Filtrar")])]) : _vm._e()], 1)], 1)], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-popover', {
    ref: "deleteAll",
    attrs: {
      "placement": "top",
      "trigger": "manual"
    },
    model: {
      value: (_vm.showPopoverCheckAll),
      callback: function($$v) {
        _vm.showPopoverCheckAll = $$v
      },
      expression: "showPopoverCheckAll"
    }
  }, [_c('div', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3"
  }, [_c('b', [_vm._v("O que deseja fazer com os registro(s) selecionado(s)?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-1"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-window-close-o",
      "type": "info",
      "size": "mini",
      "title": "Calcelar",
      "value": "Cancelar"
    },
    on: {
      "click": _vm.handleSearch
    }
  }), _vm._v(" "), (_vm.onDelete && _vm.checkItem.length > 0) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-trash",
      "type": "danger",
      "size": "mini",
      "title": _vm.onDeleteName,
      "value": _vm.onDeleteName
    },
    on: {
      "click": _vm.handleDelete
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onEditAll && _vm.checkItem.length > 0) ? _c('ed-button', {
    attrs: {
      "icon": _vm.editAllIcon,
      "type": "warning",
      "size": "mini",
      "title": _vm.editAllTitle,
      "loading": _vm.loadingEditAll,
      "value": _vm.editAllName
    },
    on: {
      "click": _vm.handleEditAll
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), (_vm.onSearch) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "10px"
    }
  }, [_c('el-select', {
    style: ('width: ' + (this.device == 'xs' ? '100%' : '220px') + ' !important'),
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.formData.ppage),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ppage", $$v)
      },
      expression: "formData.ppage"
    }
  }, _vm._l((_vm.lstPages), function(page) {
    return _c('el-option', {
      key: page,
      attrs: {
        "label": 'Exibir ' + page + ' itens por página',
        "value": page
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.disableTableContent && _vm.loadingTable),
      expression: "disableTableContent && loadingTable"
    }],
    staticClass: "col-md-12"
  }, [(_vm.tableData.length > 0) ? _vm._t("table-export") : _vm._e(), _vm._v(" "), _vm._t("table-content"), _vm._v(" "), (!_vm.disableTableContent) ? _c('b-table', {
    ref: "selectableTable",
    staticClass: "table-v2",
    attrs: {
      "id": "table-v2",
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": _vm.response && _vm.response.status && _vm.response.status != 200 ?
        _vm.response.status + (_vm.response.msg ? ' - ' + _vm.response.msg : '') :
        _vm.emptyTable,
      "busy": _vm.loadingTable,
      "items": _vm.items,
      "fields": _vm.fields,
      "stacked": this.device == 'xs',
      "sort-by": _vm.formData.sortBy,
      "sort-desc": _vm.formData.sortDesc,
      "foot-clone": _vm.tableFooter.length > 0
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.formData, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.formData, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.formData, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.formData, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(data.label) + "\n        "), (
          _vm.formData.sortBy == data.field.key && _vm.formData.sortDesc == true
        ) ? _c('i', {
          staticClass: "fa fa-sort-alpha-desc"
        }) : _vm._e(), _vm._v(" "), (
          _vm.formData.sortBy == data.field.key && _vm.formData.sortDesc == false
        ) ? _c('i', {
          staticClass: "fa fa-sort-alpha-asc"
        }) : _vm._e(), _vm._v(" "), (data.field.info) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": data.field.info,
            "placement": "top"
          }
        }, [_c('a', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fa fa-question-circle",
          attrs: {
            "aria-hidden": "true"
          }
        })])]) : _vm._e()]
      }
    }, {
      key: "foot()",
      fn: function(data) {
        return [(data.field && data.field.value != undefined) ? _c('span', [_vm._v("\n          " + _vm._s(data.field.value) + "\n        ")]) : _vm._e()]
      }
    }, {
      key: "table-busy",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center my-2",
          staticStyle: {
            "color": "var(--primary)"
          }
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _vm._v(" "), _c('strong', [_vm._v("Carregando...")])], 1)]
      },
      proxy: true
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "head(selected)",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "popover",
            rawName: "v-popover:deleteAll",
            arg: "deleteAll"
          }],
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          on: {
            "change": _vm.handleSelectAll
          },
          model: {
            value: (_vm.checkAll),
            callback: function($$v) {
              _vm.checkAll = $$v
            },
            expression: "checkAll"
          }
        })], 1)]
      }
    }, {
      key: "cell(selected)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          attrs: {
            "label": data.item._data.id
          },
          on: {
            "change": _vm.handleSelectItem
          },
          model: {
            value: (_vm.checkItem),
            callback: function($$v) {
              _vm.checkItem = $$v
            },
            expression: "checkItem"
          }
        })], 1)]
      }
    }, {
      key: "cell(tipo_status)",
      fn: function(data) {
        return [(data.item._data.tipo_status) ? _c('div', {
          style: ('color:' + data.item._data.tipo_status.cor)
        }, [(data.item._data.tipo_status.icon) ? _c('i', {
          class: data.item._data.tipo_status.icon
        }) : _vm._e(), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })]) : _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })])]
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(
          data.field && data.field.show_tipo_aso && data.item._data.tipo_aso
        ) ? _c('div', [(
          (data.field.show_consulta_link ||
            data.field.show_link_consulta) &&
          data.item._data.id_con
        ) ? _c('a', {
          attrs: {
            "href": _vm.getUrlConsulta(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              CÓD: "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')]), _vm._v(" "), _c('span', {
          style: ('font-size: 7pt; color: #666;' + (data.item.options && data.item.options.style ? data.item.options.style : ''))
        }, [_vm._v("\n              " + _vm._s(data.item._data.tipo_aso.descricao) + "\n            ")])]) : _c('span', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_vm._v("\n              " + _vm._s(data.item._data.tipo_aso.descricao) + " " + _vm._s((data.item._data.periodicidade ? data.item._data.periodicidade + ' MESES' : '')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (
          (data.field.show_consulta_link ||
            data.field.show_link_consulta) &&
          data.item._data.id_con && data.item._data.consulta
        ) ? _c('a', {
          attrs: {
            "href": _vm.getUrlConsulta(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-calendar",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$utilidade.toDate(data.item._data.consulta.dt_cad, true)))]), _c('br')])]) : (data.field && data.field.show_empresa_link) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.getUrlEmpresa(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: (data.item.options && data.item.options.style ?
            ';' + data.item.options.style :
            ''),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')]), _vm._v(" "), (data.field.show_fdt && data.item._data.fdt && data.item._data.fdt.pcmso) ? _c('span', {
          style: ('font-size:7pt;color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              ''))
        }, [_vm._v("\n              " + _vm._s(data.item._data.fdt.pcmso) + " (" + _vm._s(data.item._data.fdt.descricao) + ")\n            ")]) : _vm._e()])]) : (data.field && data.field.show_revisao_link && data.item._data.revisao_tipo) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.env.url_cs +
              '/app/' + (data.item._data.revisao_tipo) + '.php?emp=' +
              (data.item._data.empresa ? data.item._data.empresa.id : data.item._data.empresa_id) +
              '&pcmso=' + (data.item._data.fdt ? data.item._data.fdt.id : data.item._data.fdt_id) +
              '&rev=' + (data.item._data.revisao ? data.item._data.revisao.id : data.item._data.revisao_id),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: (data.item.options && data.item.options.style ?
            ';' + data.item.options.style :
            ''),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')])])]) : (
          data.field && data.field.show_funcao && data.item._data.funcao
        ) ? _c('div', [(data.field.show_funcionario_link) ? _c('a', {
          attrs: {
            "href": _vm.getUrlFuncionario(data.item._data),
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(data.value)), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n                " + _vm._s(data.item._data.funcao.nome) + "\n              ")])])]) : _c('span', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n                " + _vm._s(data.item._data.funcao.nome) + "\n              ")])])])]) : (data.field && data.field.show_financeiro_link) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.env.url_cs +
              '/app/financeiro_rel.php?cod_tp=0&cod_n=' +
              data.value,
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])])]) : (
          data.field && data.field.show_lote_link && data.item._data
        ) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.getUrlLote(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })])])]) : (
          data.field && data.field.show_user && data.item._data.usuario
        ) ? _c('div', {
          style: (data.item.options && data.item.options.style ?
            data.item.options.style :
            '')
        }, [_vm._v("\n          " + _vm._s(data.value)), _c('br'), _vm._v(" "), _c('span', {
          style: ('font-size:7pt' +
            (data.item.options && data.item.options.style ?
              data.item.options.style :
              ''))
        }, [_vm._v("\n            " + _vm._s(data.item._data.usuario.usuario) + "\n          ")])]) : (data.field && data.field.show_arquivo) ? _c('div', [(data.value && data.value.id) ? _c('Download', {
          attrs: {
            "arquivo": data.value
          }
        }) : _c('span', [_vm._v("---")])], 1) : (data.field && data.field.show_input) ? _c('div', [(data.field.edit == 'money') ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field.edit == 'number') ? _c('el-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()], 1) : (data.field && data.field.show_point) ? _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n          "), (
          data.item._data.log_acesso.usuario &&
          data.item._data.log_acesso.usuario.point
        ) ? _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('br'), _vm._v(_vm._s(data.item._data.log_acesso.usuario.point.nome) + "\n          ")]) : _vm._e()]) : (
          data.field &&
          data.field.show_status &&
          data.item._data.tipo_status
        ) ? _c('div', [_c('span', {
          style: ('color:' + data.item._data.tipo_status.cor),
          attrs: {
            "title": data.value
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : data.value
          }
        }, [(data.item._data.tipo_status.icon) ? _c('i', {
          class: data.item._data.tipo_status.icon
        }) : _vm._e(), _vm._v("\n              " + _vm._s(data.item._data.tipo_status.descricao) + "\n            ")])])]) : (
          data.field && data.field.show_rea && data.item._data.id_con_rea
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "tp-exame-rea",
          staticStyle: {
            "font-size": "9pt"
          },
          attrs: {
            "title": "Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
          }
        }, [_vm._v("\n            Exame "), _c('b', [_vm._v("reaproveitado")]), _vm._v(" da consulta\n            "), _c('label', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(data.item._data.id_con_rea))]), _vm._v(" "), (data.item._data.con_rea_dt) ? _c('span', [_vm._v("\n              em " + _vm._s(_vm.toDate(data.item._data.con_rea_dt, true)) + "\n            ")]) : _vm._e()])]) : (
          data.field && data.field.show_dem && data.item._data.id_con_dem
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "tp-exame-dem",
          staticStyle: {
            "font-size": "9pt"
          },
          attrs: {
            "title": "Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
          }
        }, [_vm._v("\n            Exame "), _c('b', [_vm._v("demonstrativo")]), _vm._v(" na consulta\n            "), _c('label', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(data.item._data.id_con_dem))]), _vm._v(" "), (data.item._data.con_dem_dt) ? _c('span', [_vm._v("\n              em " + _vm._s(_vm.toDate(data.item._data.con_dem_dt, true)) + "\n            ")]) : _vm._e()])]) : (
          data.field && data.field.show_alt && data.item._data.alt == '1'
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          staticStyle: {
            "color": "#c64747"
          },
          attrs: {
            "title": "Esse exame teve resultado alterado e deverá ser refeito no próximo periódico."
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n            " + _vm._s(data.value) + "\n          ")])]) : (
          data.field && data.field.show_parceiro && data.item._data.parceiro
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "9pt",
            "color": "#c4c4c4"
          },
          attrs: {
            "title": "Parceiro que o exame será efetuado"
          }
        }, [_vm._v("\n            " + _vm._s(data.item._data.parceiro.nome) + "\n          ")])]) : (data.field && data.field.show_json) ? _c('div', [_c('el-popover', {
          attrs: {
            "placement": "top",
            "trigger": "click"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 text-center mt-2"
        }, [_c('b', [_vm._v("Detalhes")])]), _vm._v(" "), _vm._l((data.value), function(value, field, i) {
          return _c('div', {
            key: i,
            staticClass: "col-md-12"
          }, [_c('b', [_vm._v(_vm._s(field) + ": ")]), _vm._v(" "), (field == 'exame' && value && value.nome) ? _c('span', [_vm._v("\n                  " + _vm._s(value.nome) + "\n                ")]) : (field == 'parceiro' && value && value.nome) ? _c('span', [_vm._v("\n                  " + _vm._s(value.nome) + "\n                ")]) : (field == 'created_at' || field == 'updated_at') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.toDate(value)) + "\n                ")]) : (field == 'bl_his' || field == 'bl_his') ? _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.base64Decode(value))
            }
          })]) : _c('span', [_vm._v("\n                  " + _vm._s(value) + "\n                ")])])
        })], 2), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('b-link', [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v("\n                Ver mais...\n              ")])], 1)])], 1) : (data.field && data.field.show_html) ? _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })]) : (data.field && data.field.show_colapse) ? _c('div', [(!data.value) ? _c('span', [_vm._v("---")]) : _c('el-collapse', {
          attrs: {
            "title": "Clique para mostrar mais informações"
          },
          model: {
            value: (data.item._data[data.field.key].collapse),
            callback: function($$v) {
              _vm.$set(data.item._data[data.field.key], "collapse", $$v)
            },
            expression: "data.item._data[data.field.key].collapse"
          }
        }, [_c('el-collapse-item', {
          attrs: {
            "name": data.item._data.id.toString() + data.field.key
          }
        }, [_c('template', {
          slot: "title"
        }, [(
          data.item._data[data.field.key].collapse &&
          data.item._data[data.field.key].collapse[0]
        ) ? _c('i', {
          staticClass: "fa fa-minus-circle fa-1x",
          staticStyle: {
            "color": "#28a745"
          }
        }) : _c('i', {
          staticClass: "fa fa-plus-circle fa-1x",
          staticStyle: {
            "color": "#28a745"
          }
        })]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt"
          },
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })], 2)], 1)], 1) : _c('div', {
          style: (data.item.options && data.item.options.style ?
            data.item.options.style :
            ''),
          attrs: {
            "title": data.item.options && data.item.options.title ?
              data.item.options.title :
              null
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [(
          data.field.limit &&
          data.field.limit < _vm.toString(data.value).length
        ) ? _c('span', [_c('el-popover', {
          attrs: {
            "placement": "top",
            "trigger": "click"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 p-5"
        }, [_vm._v("\n                    " + _vm._s(data.value) + "\n                  ")])]), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('b-link', [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v("\n                    Ver mais...\n                  ")])], 1)])], 1) : _c('span', [(
          data.item &&
          data.item._data &&
          ((_vm.onEditAll &&
              _vm.checkItem.indexOf(data.item._data.id) != -1) ||
            _vm.editableRows)
        ) ? _c('span', [(data.field.edit == 'money') ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field.edit == 'text') ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (
          data.field.edit == 'select-custom' &&
          _vm.config.click &&
          _vm.config.click[data.field.key] &&
          _vm.config.list &&
          _vm.config.list[data.field.key]
        ) ? _c('el-select', {
          attrs: {
            "loading": _vm.config.loading[data.field.key],
            "placeholder": 'Pesquisar...',
            "filterable": "",
            "remote": "",
            "remote-method": _vm.config.click[data.field.key],
            "value-key": "id"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }, _vm._l((_vm.config.list[data.field.key]), function(val, j) {
          return _c('el-option', {
            key: j,
            attrs: {
              "label": val.nome,
              "value": val.id
            }
          })
        }), 1) : _c('span', [_vm._v("\n                  " + _vm._s(data.value) + "\n                ")])], 1) : _c('span', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _vm._v(" "), (
          data.field && data.field.show_cnpj && data.item._data.cnpj
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "CNPJ"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-credit-card-alt",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.cnpj) + "\n                ")]) : _vm._e(), _vm._v(" "), (
          data.field && data.field.show_cpf && data.item._data.cpf
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "CPF"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-address-card",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.cpf) + "\n                ")]) : _vm._e(), _vm._v(" "), (
          data.field &&
          data.field.show_telefone &&
          _vm.onlyNumber(data.item._data.telefone)
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "Telefone"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-phone-square",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.telefone) + "\n                ")]) : _vm._e()])])])])]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center tbutton"
        }, [(
          _vm.onEdit &&
          (!data.item.options ||
            (data.item.options && !data.item.options.disable_edit))
        ) ? _c('ed-button', {
          staticStyle: {
            "margin": "2px"
          },
          attrs: {
            "icon": "fa fa-pencil-square-o",
            "type": "primary",
            "size": "mini",
            "title": "Editar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(data.item._data)
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm._l((data.value), function(button, i) {
          return _c('ed-button', {
            key: i,
            staticStyle: {
              "margin": "2px"
            },
            style: (button.style),
            attrs: {
              "icon": button.icon,
              "type": button.color,
              "size": "mini",
              "title": button.title
            },
            on: {
              "click": function($event) {
                return button.click(data.item._data)
              }
            }
          })
        }), _vm._v(" "), (
          _vm.onDelete &&
          (!data.item.options ||
            (data.item.options && !data.item.options.disable_delete))
        ) ? _c('ed-button', {
          staticStyle: {
            "margin": "2px"
          },
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": _vm.onDeleteName
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(data.item._data)
            }
          }
        }) : _vm._e()], 2)]
      }
    }], null, false, 3590096355)
  }) : _vm._e(), _vm._v(" "), (_vm.pagination && _vm.pagination.total && _vm.pagination.total > 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('ed-paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "navigation": _vm.handleNavigate
    }
  })], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-500012bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/table.vue
// module id = 1472
// module chunks = 45